import { render, staticRenderFns } from "./task-form.vue?vue&type=template&id=6fcfc8b2&scoped=true&"
import script from "./task-form.vue?vue&type=script&lang=js&"
export * from "./task-form.vue?vue&type=script&lang=js&"
import style0 from "./task-form.vue?vue&type=style&index=0&id=6fcfc8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcfc8b2",
  null
  
)

export default component.exports